<template>
  <div>
    <div class="play_foot clearfix" v-show="play_close && footerShow">
      <img src="@a/play_close.png" v-show="!js_play" @click="play_close=false">
      <div class="play_f" :class="{pause_h2: js_play}">
        <h2>{{loca_name}}</h2>
        <h3>{{strTime}}</h3>
      </div>
      <router-link :to="{path: loca_href, query: url_query}" class="loca_h"></router-link>
    </div>
  </div>
</template>
<script>
import {
  getStorage
} from "@/utils/tools"
export default {
  data() {
      return {
        play_close: false,
        js_play: false,
        loca_name: "",
        strTime: "",
        loca_href: "",
        url_query: {}
      }
    },
    props: ['footerShow'],
    methods: {
      getaudio() {
        let storaPath = '/course_content';
        let audiotitle = getStorage(storaPath, 'title');
        let strTime = getStorage(storaPath, 'strTime');
        this.url_query = JSON.parse(getStorage(storaPath, 'query'));
        if (audiotitle) {
          this.play_close = true;
          this.loca_name = audiotitle;
          this.strTime = strTime;
          this.loca_href = `${storaPath}`;
        }
      },
    },
    mounted() {
      this.getaudio()
    },
}
</script>
<style lang="scss" scoped>
@import "../style/remChange.scss";
.play_foot {
  width: changeRem(13.8) + px;
  height: changeRem(2) + px;
  position: fixed;
  bottom: changeRem(2.56) + px;
  left: 50%;
  margin-left: changeRem(-6.9) + px;
  text-align: left;
  background: rgba(51, 51, 51, 0.7);
  border-radius: changeRem(0.16) + px;
  padding: changeRem(0.3) + px changeRem(0.6) + px;
  img {
    width: changeRem(0.96) + px;
    display: inline-block;
    margin-right: changeRem(0.6) + px;
    float: left;
    margin-top: changeRem(.2) + px;
    transition: all 0.5s;
  }
  .play_f {
    width: changeRem(8.4) + px;
    float: left;
    h2 {
      color: #fff;
      font-size: changeRem(.56) + px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    h3 {
      color: #f0f0f0;
      font-size: changeRem(.4) + px;
    }
  }
  .loca_h {
    display: block;
    float: right;
    width: changeRem(1.4) + px;
    height: changeRem(1.4) + px;
    background: url(../assets/jinru.png) top center no-repeat;
    background-size: cover;
  }
}
</style>
